import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import closeIcon from "../../../../../assets/icons/dashboard-x-close.svg";
import UserGroupForm from "../../UserGroupForm/UserGroupForm";

function UserGroupModal({ id, open, handleClose, data, ...rest }) {
  return (
    <Dialog
      open={open}
      onClose={(e, reason) => {}}
      className="ta-modal user_modal group_modal dashboard-group-modal"
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "829px"
          }
        }
      }}
    >
      <DialogTitle id="alert-dialog-title" className="modal_title">
        <span className="label">{data?.isEdit ? "Edit group" : "Add a new group"}</span>
        <span className="close-btn" onClick={() => handleClose(id)}>
          <img src={closeIcon} alt="" />
        </span>
      </DialogTitle>
      <p className="subtitle">
        {!data?.isEdit ? "Let's create a new group together." : "Let's update an existing group"}
      </p>

      <DialogContent className="ta-modal-content-scroll">
        <UserGroupForm
          isEdit={data?.isEdit || false}
          id={data?.isEdit ? data?.id : null}
          group={data?.isEdit ? data?.group : null}
        />
      </DialogContent>
    </Dialog>
  );
}

export default UserGroupModal;
